import { formatZeroAmount } from '@/utils/formatAmount';

/** BE sentinel for missing total amount; formatZeroAmount leaves it unchanged. */
const API_EMPTY_SENTINEL = '-';

const MISSING_FALLBACK = {
  list: '',
  drawer: '- 円',
} as const;

export type ConfirmModalTotalAmountSource = keyof typeof MISSING_FALLBACK;

/** Formats total amount for confirm modals. `list` → blank when missing; `drawer` → '- 円'. */
export const formatConfirmModalTotalAmount = (
  totalValue?: string | null,
  source: ConfirmModalTotalAmountSource = 'list'
): string => {
  const missingFallback = MISSING_FALLBACK[source];

  if (totalValue === API_EMPTY_SENTINEL) {
    return missingFallback;
  }

  return formatZeroAmount(totalValue) || missingFallback;
};
